<template>
  <!-- Playbook Description Modal -->
  <div class="modal fade" id="playbook-description-modal" tabindex="-1" aria-labelledby="playbook-description-modal-label" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header"> 
          <h2 class="m-2">{{ local_playbook_type.name }}</h2>
          <button type="button" class="btn btn-white float-end close-modal"  :data-bs-dismiss="'#playbook-description-modal'" @click.prevent="closeModal()" data-bs-toggle="tooltip" title="Close"> 
            <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
          </button>
        </div>

        <div class="modal-body py-0">
          <div class="playbook_description--body">
            <div class="row mb-3">
              <div class="col-12">
                <div class="card mb-3">
                  <div class="card-body p-4">
                    <h4 class="mb-3">Why should you run this play?</h4>
                    <div v-if="local_playbook_type.embed_text" class="d-flex justify-content-between align-items-center mb-3">
                      <a href="javascript:void(0)" @click="openVideoModal" class="text-decoration-none d-flex align-items-center">
                        <svg class="me-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M10 8L16 12L10 16V8Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        View video
                      </a>
                    </div>

                    <p v-if="local_playbook_type.html" class="mb-3" v-html="local_playbook_type.html"></p>
                    <p v-else class="mb-3">{{ local_playbook_type.description }}</p>

                    <div class="mt-4 pt-2 border-top">
                      <div class="row mt-3">
                        <div class="col-12 col-md-6 mb-3">
                          <div class="d-flex flex-wrap align-items-center">
                            <span class="fw-medium me-2 mb-1">Focus:</span>
                            <template v-for="strategy in (local_playbook_type.strategy || [])" :key="strategy" v-if="local_playbook_type.strategy">
                              <span class="badge badge-secondary me-2 mb-1 p-1 px-2 d-inline-flex align-items-center">
                                {{ strategy }}
                              </span>
                            </template>
                            <span v-else  class="badge badge-secondary me-2 mb-1 p-1 px-2 d-inline-flex align-items-center">Conversion</span>
                          </div>
                        </div>

                        <!-- <div class="d-flex col-6 align-items-center mb-2">
                          <span class="fw-medium me-2">Type:</span>
                          <span>{{ local_playbook_type.name }}</span>
                        </div> -->

                        <div class="col-12 col-md-6 mb-3">
                          <div class="d-flex align-items-center">
                            <span class="fw-medium me-2">Setup time:</span>
                            <span>{{ 10 + (local_playbook_type.asset_types ? local_playbook_type.asset_types.length * 3 : 0) }} minutes</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="local_asset_types.length > 0" class='col-12'>
                <div class="card mb-3">
                  <div class="card-body p-4">
                    <h4 class="mb-3">Channels</h4>
                    <div class="row g-4">
                      <div v-for="asset_type in local_asset_types" :key="asset_type.id" class="col-6 d-flex align-items-center">
                        <span class="me-2">
                          <img :src="'/img/icons/avid-icons/' + asset_type.icon_class + '.svg'" class="asset-type-icon icon" alt=""></img>
                        </span>
                        <span>{{ asset_type.name }}</span>
                        <span v-if="asset_type.count" class="text-muted ms-1">({{ asset_type.count }})</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <playbook-description-projection></playbook-description-projection> -->

          </div>

          <!-- Video Modal -->
          <div class="modal fade" id="playbook-video-modal" tabindex="-1" aria-labelledby="playbook-video-modal-label" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title" id="playbook-video-modal-label">{{ (local_playbook_type.name || 'Loading...') + ' Video' }}</h4>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal" data-bs-toggle="tooltip" title="Close"></button>
                </div>
                <div class="modal-body">
                  <div style="position: relative; padding-bottom: 56.25%; height: 0;">
                    <div v-html="local_playbook_type.embed_text"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import permissionsMixin from '../../mixins/permissions';
import { usePlaybookStore } from '../../stores/playbook';
import { useClientStore } from '../../stores/client';

export default defineComponent({
  name: 'PlaybookTypeInformationModal',
  mixins: [permissionsMixin],
  props: {
    playbook_type: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      local_playbook_type: {},
      local_asset_types: [],
      // Video modal
      video_modal: null,
      // Main modal
      description_modal: null,
      modal_initialized: false,
      // Default video URL - replace with actual video URL when available
      video_url: 'https://www.loom.com/embed/c5f7c145864b48778674d4317feb64b4'
    }
  },
  setup() {
    const playbookStore = usePlaybookStore();
    const clientStore = useClientStore();
    return {
      playbookStore,
      clientStore
    };
  },
  computed: {
    client() {
      return this.clientStore.getClient;
    }
  },
  beforeMount() {
    this.local_playbook_type = this.playbook_type
    if (this.local_playbook_type.asset_types) {
      this.loadAssetsTypes()
    }
  },
  mounted() {
    // Initialize the video modal
    this.video_modal = new bootstrap.Modal(document.getElementById('playbook-video-modal'))
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
        this.$nextTick(() => {
          // Initialize the description modal when it's about to be shown
          if (!this.modal_initialized) {
            const modalElement = document.getElementById('playbook-description-modal')
            if (modalElement) {
              this.description_modal = new bootstrap.Modal(modalElement)
              
              // Add event listener for when modal is hidden (only once)
              modalElement.addEventListener('hidden.bs.modal', () => {
                this.$emit('update:show', false)
              })
              
              this.modal_initialized = true;
            } else {
              console.error('Modal element not found!');
            }
          }
          this.showModal()
        })
        } else {
          this.hideModal()
        }
      },
      immediate: true
    },
    playbook_type: {
      handler(newPlaybookType, oldPlaybookType) {
        // Only update if the playbook_type actually changed (different ID)
        if (!oldPlaybookType || newPlaybookType.id !== oldPlaybookType.id) {
          // Create a deep copy to avoid modifying the original data
          this.local_playbook_type = JSON.parse(JSON.stringify(newPlaybookType));
          if (this.local_playbook_type.asset_types) {
            this.loadAssetsTypes();
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    loadAssetsTypes() {
      var temp = []
      this.local_playbook_type.asset_types.forEach(asset_type => {
        var index = temp.findIndex(a => a.id == asset_type.id)
        if (index == -1) {
          asset_type.count = 1
          temp.push(asset_type)
        } else {
          temp[index].count++
        }
      })
      this.local_asset_types = temp
    },
    openVideoModal() {
      this.video_modal.show()
    },
    showModal() {
      if (this.description_modal) {
        this.description_modal.show()
      }
    },
    hideModal() {
      if (this.description_modal) {
        this.description_modal.hide()
      }
    },
    closeModal() {
      this.$emit('update:show', false)
    }
  }
})
</script>